// Show types
export const QUESTION_SHOW_SUCCESS = 'QUESTION_SHOW_SUCCESS';
export const QUESTION_SHOW_RESET = 'QUESTION_SHOW_RESET';

// Answer
export const QUESTION_SET_SELECTED_ANSWER = 'QUESTION_SET_SELECTED_ANSWER';
export const QUESTION_SET_IS_FANTASY = 'QUESTION_SET_IS_FANTASY';
export const QUESTION_SET_IS_ACTION = 'QUESTION_SET_IS_ACTION';
export const QUESTION_SET_GAUGE_LEVEL = 'QUESTION_SET_GAUGE_LEVEL';
export const QUESTION_SET_NEXT = 'QUESTION_SET_NEXT';

//Finished
export const QUESTION_FINISHED_SUCCESS = 'QUESTION_FINISHED_SUCCESS';
export const QUESTION_FINISHED_RESET = 'QUESTION_FINISHED_RESET';

// Bookmark
export const QUESTION_SET_BOOKMARK = 'QUESTION_SET_BOOKMARK';



// WEBPACK FOOTER //
// ./src/store/modules/question/mutation-types.js